
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/users",
      function () {
        return require("private-next-pages/docs/api/users/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/users"])
      });
    }
  